<template>
    <modal name="employee-loan-transfer" :width="600" height="auto" :adaptive="true" :scrollable="true" :click-to-close="false">
        <div style="padding:20px">
            <h4>Transfer loan accounts</h4>
            <p v-if="source">From: <strong>{{ source.name }} {{ source.generatedid }}</strong></p>
            <div v-if="error" class="alert alert-danger">{{ error }}</div>
            <div class="form-group">
                <label>Replacement employee</label>
                <select v-model="targetId" class="form-control" :disabled="busy">
                    <option value="">Select an active employee</option>
                    <option v-for="employee in targets" :key="employee.id" :value="employee.id">{{ employee.name }} {{ employee.generatedid }}</option>
                </select>
            </div>
            <div class="form-group">
                <label>Accounts to transfer</label>
                <select v-model="scope" class="form-control" :disabled="busy" @change="preview = null">
                    <option value="open">Open / dues accounts only</option>
                    <option value="all">All accounts, including cleared / closed</option>
                </select>
            </div>
            <button class="btn btn-primary" :disabled="busy || !targetId" @click="loadPreview">{{ loading ? 'Loading...' : 'Preview transfer' }}</button>
            <div v-if="preview" style="margin-top:15px">
                <p><strong>{{ preview.count }}</strong> accounts will be transferred. Assignment history will be retained.</p>
                <p v-if="transferring || completed">Transferred {{ completed }} of {{ preview.count }} accounts.</p>
                <div v-if="transferring" class="progress"><div class="progress-bar" :style="{ width: progress + '%' }">{{ progress }}%</div></div>
                <button class="btn btn-success" :disabled="busy || !targetId || !preview.count || finished" @click="transfer">Confirm transfer</button>
            </div>
            <div v-if="finished" class="alert alert-success" style="margin-top:15px">Transfer complete: {{ completed }} accounts reassigned.</div>
            <button class="btn btn-default" style="margin-top:15px" :disabled="busy" @click="$modal.hide('employee-loan-transfer')">Close</button>
        </div>
    </modal>
</template>

<script>
export default {
    data() {
        return { source: null, targetId: '', targets: [], scope: 'open', preview: null, loading: false, transferring: false, completed: 0, finished: false, error: '' }
    },
    computed: {
        busy() { return this.loading || this.transferring },
        progress() { return this.preview && this.preview.count ? Math.min(100, Math.round(this.completed * 100 / this.preview.count)) : 0 },
    },
    methods: {
        errorText(error) {
            const data = error.response && error.response.data
            const messages = data && data.errors && Object.values(data.errors)
            return messages && messages.length ? messages[0][0] : (data && data.message) || 'Unable to process the transfer. Please try again.'
        },
        async open(employee) {
            if (this.busy) return
            this.source = employee
            this.targetId = ''
            this.targets = []
            this.scope = 'open'
            this.preview = null
            this.completed = 0
            this.finished = false
            this.error = ''
            this.$modal.show('employee-loan-transfer')
            this.loading = true
            try {
                const response = await this.$http.post('api/loan-accounts/transfer/employees', { source_id: employee.id })
                this.targets = response.data.employees
            } catch (error) { this.error = this.errorText(error) }
            finally { this.loading = false }
        },
        async loadPreview() {
            if (this.busy || !this.targetId) return
            this.error = ''
            this.preview = null
            this.completed = 0
            this.finished = false
            this.loading = true
            try {
                const response = await this.$http.post('api/loan-accounts/transfer/preview', { source_id: this.source.id, target_id: this.targetId, scope: this.scope })
                this.preview = response.data
            } catch (error) { this.error = this.errorText(error) }
            finally { this.loading = false }
        },
        async transfer() {
            if (this.busy || this.finished || !this.preview || !this.preview.count || !this.targetId) return
            this.transferring = true
            this.error = ''
            let afterId = 0
            // Freeze the selected employees and account scope for all batches.
            const parameters = { source_id: this.source.id, target_id: this.targetId, scope: this.scope, max_id: this.preview.max_id }
            try {
                let more = true
                while (more) {
                    const response = await this.$http.post('api/loan-accounts/transfer/batch', { ...parameters, after_id: afterId })
                    this.completed += response.data.transferred
                    afterId = response.data.last_id
                    more = response.data.has_more
                }
                this.finished = true
            } catch (error) {
                this.error = this.errorText(error) + ' ' + this.completed + ' accounts were transferred. Preview again to transfer the remaining accounts.'
                this.preview = null
            } finally {
                this.transferring = false
                this.$emit('updated')
            }
        },
    },
}
</script>
